module.exports = __webpack_public_path__ + "static/img-team-49b7deac2407e45fe4711beea4733845.svg";